import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import * as ActionTypes from "@/stores/sale/actions"
import { Select } from "@tencent/spaui"
import { withApi } from "@tencent/react-aio"
import { connect } from "react-redux"
import MessageBox from "@/components/MessageBox"

// 多选下单产品
const reportHubDefaultKey = 'ordering-product-select';

class OrderingProductSelect extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    // productList: PropTypes.arrayOf(PropTypes.object),
  }

  state = { productList: [] }
  // orderingProductId;
  // orderingProductName;

  componentDidMount() {
    const { webApi } = this.props
    const { productList } = this.state
    if (_.isEmpty(productList)) {
      webApi
        .getOrderingProductList()
        .dispatchJson(ActionTypes.FETCH_ORDERING_PRODUCT_LIST)
        .then(
          (resp) => {
            this.setState({
              productList: resp,
            })
          },
          (error) => {
            this.context.error("获取自定义列失败", error.message)
          }
        )
    }
  }

  render() {
    const { value, onChange, onClear, reportHubKey } = this.props
    const reportKey = reportHubKey || reportHubDefaultKey;
    const { productList } = this.state
    let data = _.map(productList, (message) => {
      return {
        value: message.orderingProductId,
        label: message.orderingProductName,
        'data-report': `${reportKey}-${message.orderingProductId}`,
      }
    })

    data = _.compact(data)

    return <Select
      data-report={reportKey}
      clear={true}
      multiple
      onClear={onClear}
      className="EducationSelect"
      data={data}
      value={value}
      onChange={onChange}
    />
  }
}

function mapStateToProps(state, ownProps) {
  return {
    productList: state.productList,
  }
}

OrderingProductSelect.contextType = MessageBox

export default withApi(connect(mapStateToProps)(OrderingProductSelect))
